export default function () {
  if (this.$route.name === 'EditBlogPost') {
    this.loadPost()
  }
}
